import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import HeaderOrg from "../Headers/HeaderOrg";
import CollaboratorModal from "../../Components/Modals/OrganizerModel/ManageFeis/Events/CollaboratorModal";
import CollaboratorPicker from "../../Components/Modals/OrganizerModel/CollaboratorPicker/CollaboratorPicker";
import AddCollaboratorModal from "../../Components/Modals/OrganizerModel/ManageFeis/Events/AddCollaboratorModal";
import { SET_MODAL } from "../../redux/actionTypes/modalActionType";
import ManageTitle from "../../Components/TitleElements/ManageTitle";
import Loader from "../../Components/Loader/Loader";
import { serviceConsumer } from "../../network/ServiceConsumer";
import { manageOireachtasArray } from "./ManageOireachtasArray";
import "../ManageFeisGrade/ManageFeisGrade.css";

// B0 — the Oireachtas manage dashboard (tabulation-and-results.md §12). A card
// grid mirroring ManageFeisGrade, mostly the event-day tools (draw, check-in)
// plus view/export placeholders that fill in across B2–B5. Organizer + admin
// only; the backend enforces the gate, this is just the entry surface.
const ManageOireachtas = () => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modalReducer);
  const eventId = new URLSearchParams(location.search).get("id");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await serviceConsumer("GET", `${process.env.REACT_APP_BASE_URL}/oireachtas/${eventId}`);
        setEvent(res.event);
      } catch (e) {
        // errors surface via the empty-state below
      } finally {
        setLoading(false);
      }
    };
    if (eventId) load();
  }, [eventId]);

  const openModal = (name) =>
    dispatch({ type: SET_MODAL, payload: { modal: name, eventId } });

  // the shared modal store outlives this page; don't leave a modal open behind it
  useEffect(() => () => dispatch({ type: SET_MODAL, payload: { modal: "", eventId: "" } }), [dispatch]);

  const cardClick = (card) => {
    if (card.disabled) return;
    if (card.modal) return openModal(card.modal);
    if (!card.path) return;
    // Wizard-tab cards (e.g. Fees) re-open the creation wizard in edit mode
    // on a specific tab — same localStorage arming as the events list uses.
    if (card.wizardTab) {
      localStorage.setItem("organizerId", event?.organizer_id || "");
      localStorage.setItem("ID", eventId);
      localStorage.setItem("page", event?.page || "6");
      localStorage.setItem("TAB", card.wizardTab);
      navigate(`${card.path}?id=${eventId}`);
      return;
    }
    const extra = card.query
      ? "&" + new URLSearchParams(card.query).toString()
      : "";
    navigate(`${card.path}?id=${eventId}${extra}`);
  };

  const backClickHandler = () => setTimeout(() => navigate("/oireachtas"), 300);

  const eventDate = (event?.eventDays && event.eventDays[0]) || event?.entriesCloseDate;

  return (
    <>
      {loading && <Loader />}
      <HeaderOrg />
      <ManageTitle
        eventLogo={event?.logo}
        eventName={event?.name}
        eventType={event?.eventType}
        eventDate={eventDate}
        loading={loading}
        onBackClick={backClickHandler}
      />
      <div className="db-body">
        {!loading &&
          manageOireachtasArray.map((section) => (
            <React.Fragment key={section.mainTitle}>
              <div className="org-body-title pt-4">{section.mainTitle}</div>
              <div className="mt-1 hr-org-body" />
              <div className="managecard-list mt-4">
                {section.details.map((card) => (
                  <div
                    key={card.title}
                    className={card.disabled ? "managecardDisabled" : "managecard"}
                    style={{ columnGap: "10px" }}
                    onClick={() => cardClick(card)}
                  >
                    <img className="manage-img" src={card.logo} alt="" />
                    <div>
                      <div className="managecard-head">{card.title}</div>
                      <div className="managecard-descr mt-1">{card.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}
        <ToastContainer />
      </div>
      {/* Adjudicators: the feis manage screen's list -> type-ahead picker ->
          new-record flow, on the /people routes (they serve Oireachtas events) */}
      {modal.modal === "Adjudicators" && (
        <CollaboratorModal
          modalState={true}
          title="Adjudicators"
          collaborator="adjudicators"
          btnName="Add adjudicator"
          manageType="feis"
        />
      )}
      {modal.modal === "SelectOldAdjudicators" && (
        <CollaboratorPicker
          open
          allowEmail
          type="adjudicator"
          eventId={modal.eventId}
          kind="feis"
          onClose={() => openModal("Adjudicators")}
          onAddNew={() => openModal("NewAdjudicators")}
        />
      )}
      {modal.modal === "NewAdjudicators" && (
        <AddCollaboratorModal
          modalState={true}
          title="Adjudicator"
          btnName="adjudicator"
          manageType="feis"
        />
      )}
    </>
  );
};

export default ManageOireachtas;
